<template>
  <div class="main-page-module">

    <div class="top-header d-flex flex-row justify-content-between mt-3">

      <div class="logo-box d-flex align-items-center">
        <img src="~@/assets/logo.png" class="logo" />
        <p>کیشـوتو</p>
      </div>

      <div class="mx-auto">
        <a referrerpolicy="origin" target="_blank" href="https://trustseal.enamad.ir/?id=206498&amp;Code=rBIuzfsN7ucAZxLAYeTY">

       <!-- <picture>
          <source media="(max-width: 650px)" style="width:100%;height:100%" srcset="~@/assets/img/logo/enamad.png">
          <source media="(min-width: 650px)" style="width:100%;height:100px" srcset="~@/assets/img/logo/enamad.png">
          <img src="~@/assets/img/logo/enamad.png" style="width:100%;">
        </picture>-->

                <img style="width:90px;height:76px;cursor:pointer" referrerpolicy="origin" src="~@/assets/img/logo/enamad2.png" alt=""  id="rBIuzfsN7ucAZxLAYeTY">
        <!--<img referrerpolicy="origin" src="https://Trustseal.eNamad.ir/logo.aspx?id=206498&amp;Code=rBIuzfsN7ucAZxLAYeTY" alt="" style="cursor:pointer" id="rBIuzfsN7ucAZxLAYeTY">-->

      </a>
      </div>

      <div class="profile-image header-item-right" v-if="loggined">
        <router-link tag="div" to="/profile" class="profile-pic" :style="{'background-image': userData.avatar === '' ? 'url(' + require('../../assets/img/profile/image.jpg') + ')' : `url(https://kishoto.ir/dtr/approid/img/${userData.avatar})`,'background-size': 'contain'}"></router-link>
      </div>


      <div class="cloud-image-box header-item-right cloud-image d-flex align-items-center justify-content-end" v-else>
        <router-link to="/login">
          <img src="~@/assets/img/main/door.png" />
        </router-link>
        <!--<img src="~@/assets/img/cloud/clou04.png" class="cloudimage" />--></div>
    </div>


    <div class="top-cloud">
      <img src="~@/assets/img/cloud/clou03.png" class="cl-1" />
      <img src="~@/assets/img/cloud/clou01.png" class="cl-2" />
      <img src="~@/assets/img/cloud/clou02.png" class="cl-3" />
    </div>

    <div class="container">

      <div class="slider">
        <div v-swiper:mySwiper="options">
          <div class="swiper-wrapper">
            <router-link tag="div" to="/live"
              v-for="item in slider"
              :key="item.id"
              class="img-wrapper swiper-slide"
            >
              <img :src="`https://kishoto.ir/dtr/approid/img/${item.image}`" />
            </router-link>

          </div>
        </div>
      </div>

      <div class="login" v-if="!loggined">
        <br>
      <!--  <router-link to="/login">
          <img src="~@/assets/img/main/door.png" />
        </router-link>-->
      </div>

      <router-link tag="div" to="/events" class="balon">
        <img src="~@/assets/img/main/ballon1.png" />
      </router-link>

      <div class="airplane">
        <router-link tag="a" to="/packages">
        <!--<a href="/packages"> router-link tag="a" to="/packages"-->
          <img src="~@/assets/img/main/plane4.png"/>
        </router-link>
      </div>
      <router-link tag="div" to="/voting" class="mosabeghe" >
        <img src="~@/assets/img/main/mosabeghe.png" />
      </router-link>
    </div>
    <div class="isalnd">
      <div class="mall">
        <!--<img @click="commingsoon" src="~@/assets/img/main/main_filimoboard.png" class="filimo-img" />-->
        <router-link custom v-slot="{navigate}" to="/asnaf" >
          <img src="~@/assets/img/main/mallmain.png" @click="navigate" class="mall-img">
        </router-link>

      </div>
    </div>
    <div class="underwater">
      <div class="container">
        <UnderWater @commingsoon="commingsoon" />
        <Partners class="partners" />
      </div>
    </div>
  </div>
</template>

<script>
import UnderWater from "../../components/Home/UnderWater/UnderWater";
import Partners from "../../components/Home/Partners/Partners";
import store from "./../../store";

export default {
  data() {
    return {
      slider: null,
      options: {
        slidesPerView: 1,
        loop: false,
      },
      loggined:false,
      userData:null
    };
  },
  components: {
    UnderWater,
    Partners,
  },
  created() {
    this.getSlider();
    this.authcheck();
  },
  methods: {
    async getSlider() {
      const response = await this.$ApiServiceLayer.post("main_slider");
      if (response.status_code === 200) {
        this.slider = response.list;
      }
    },
    commingsoon(value){
      this.$toast.open({
        message: 'به زودی ...',
        type: 'info',
      });
    },
    authcheck(){
      console.log("checking auth");
      console.log("this is new js file! 2");

      if(store.state.login.loginTempToken){
        this.getProfile();
        this.loggined = true;
        console.log("loggined!");
      }else{
        this.loggined = false;
        console.log("not loggined!");
      }
    },
    async getProfile() {
      let fd = new FormData();
      fd.append("token", store.state.login.loginTempToken);
      const response = await this.$ApiServiceLayer.post("get_profile", fd);

      console.log(response);

      if(typeof response.data != "undefined"){
        if(response.data.status_code === 500) {
          console.log("this is new js file! 2");
          window.localStorage.removeItem("kishoto-store");
          window.localStorage.removeItem("token");

          setTimeout(()=>{
            window.open("/","_self");
          },2000);
          //this.userData = response;
        }
      }

      if(response.status_code === 200) {
        this.userData = response;
      }

      if(response.status_code === 500) {
        console.log("this is new js file! 2");
        window.localStorage.removeItem("kishoto-store");
        window.localStorage.removeItem("token");

        setTimeout(()=>{
          window.open("/","_self");
        },2000);
        //this.userData = response;
      }

    }

  },
};
</script>

<style lang="scss" scoped>
.main-page-module {
  width: 100%;
  height: 100%;
  background: rgb(157 208 250 / 45%);
  background: linear-gradient(
          3deg
      , rgb(255 255 255) 0%, rgb(119 190 248 / 51%) 47%, rgba(72,168,245,1) 100%);
  position: relative;
  overflow: hidden;
  .top-header{
    width: 100%;
    height: 70px;
    .logo-box{
      background: #ffffff36;
      border-radius: 22px;
      margin-left: 14px;
      padding-right: 45px;
      height: 64px;

      .logo{
        height: 100%;
      }
      p{
        color: #ffff;
        font-weight: bold;
        font-size: 23px;
        font-family: 'homa';
        margin: 0;
        text-shadow: 0px 3px 4px #010716a3;
      }
    }

    .profile-pic {
      width: 67px;
      height: 67px;
      border-radius: 50%;
      border: 2px solid #fff;
      background-color: #fff;
      margin-right: 21px;
    }
    .cloud-image-box {
      width: 100%;
      height: 38px;
      margin-right: 21px;
      img {
        width: 83px;
        height: 100%;
        object-fit: contain;
        margin-top: 27px;
      }
    }


  }
  .top-cloud {
    width: 100%;
    height: 150px;
    position: relative;
    .cl-1 {
      width: 120px;
      height: 80px;
      object-fit: contain;
      position: absolute;
      right: 10%;
      top: 13px;
    }

    .cl-2 {
      width: 180px;
      height: 120px;
      object-fit: contain;
      position: absolute;
      left: 8%;
      top: 15%;
    }

    .cl-3 {
      width: 110px;
      height: 70px;
      object-fit: contain;
      position: absolute;
      top: 50%;
      right: 5%;
    }
  }
  .slider {
    width: 100%;
    height: 200px;
    .swiper-wrapper {
      width: 100%;
      height: 100%;
      .swiper-slide {
        width: 100%;
        height: 100%;
        img {
          width: 100%;
          height: 100%;
          border-radius: 20px;
        }
      }
    }
  }

  .login {
    width: 100%;
    height: 38px;
    margin-top: 70px;
    display: flex;
    justify-content: flex-end;
    img {
      width: 150px;
      height: 100%;
      object-fit: contain;
    }
  }

  .balon {
    width: 100%;
    height: 300px;

    img {
      width: 250px;
      height: 300px;
      object-fit: contain;
    }
  }

  .airplane {
    height: 200px;
    position: relative;
    img {
      width: 300px;
      height: 200px;
      position: absolute;
      right: -100px;
      transform: rotate(20deg);
    }
  }

  .mosabeghe {
    width: 100%;
    height: 300px;
    position: relative;
    img {
      width: 250px;
      height: 200px;
      object-fit: contain;
      position: absolute;
      right: -20px;
    }
  }

  .isalnd {
    width: 100%;
    height: 200px;
    background-image: url("~@/assets/img/main/island2.png");
    background-size: cover;
    background-position: center;
    .mall {
      width: 100%;
      height: 200px;
      display: flex;
      justify-content:center;
      //justify-content:flex-end;
      .mall-img {
        width: 250px;
        height: 250px;
        object-fit: contain;
        margin-top: -50px;
      }
      .filimo-img {
        width: 70px;
        height: 100px;
        object-fit: contain;
        margin-top: 75px;
        margin-left: 20px;
      }
    }
  }

  .underwater {
    min-height: 900px;
    width: 100%;
    background-image: url("~@/assets/img/bg/main_down.png");
    margin-top: -35px;
    background-size: cover;
    background-position: top center;
    padding-top: 100px;

    .partners {
      margin-top: 150px;
    }
  }
}


@media screen and (min-width: 800px) {
  .main-page-module .slider .swiper-wrapper .swiper-slide {
    display: flex;
    justify-content: center;
    img{
      width: 53% !important;

    }
  }
}
</style>
